var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/energy_billing.template.html');

var TheView = GenericView.extend({
    el: '#energy',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "energy");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        'change input[name="energy_billing"]': 'enableRightField',
        "input .to-validation input": "validateIt"
    },
    enableRightField: function() {
        $("#energy").find(".disabled").removeClass("disabled");
        $("#energy ." + $("input[name='energy_billing']:not(:checked)").val()).addClass("disabled");
        if ( $("#energy .SelfConsumption").hasClass("disabled") )
            $("#energy .SelfConsumption").find(".to-validation").removeClass("to-validation");
        else
            $("#energy .SelfConsumption").find(".addVal").addClass("to-validation");
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    getAllData: function() {
        var data = {
            self_consumption: this.convertToFloat("#self_consumption"),
            net_metering: this.convertToInt("input[name='billing_period']:checked"),
            policy: $("input[name='energy_billing']:checked").val()
         };

         return data;
    }
});

module.exports= TheView;